import { teApi } from 'yxt-biz-pc/packages/api';

// 学员端-获取教学身份/教学信息
export const getTeachingIdentityInfo = (query) => {
  return teApi.get('stu/authentication/user', { params: query });
};

// 学员端-获取认证基本信息
export const getAuthenticationInfo = (id) => {
  return teApi.get('stu/authentication/detail', { params: id });
};
